import api, { request } from '../../../../../../api';
import { isError } from '../../../../../../contrib/Utils/isError';
import { ILeaderboard, IStateDispatchActions } from '../ContestSetup.context';

export type IUpdateEnrollments = (
  clubId: number,
  eventId: number,
  roundId: number,
  leaderboardId: number,
  enrollments: number[]
) => Promise<void>;

export const updateEnrollments: IStateDispatchActions<IUpdateEnrollments> = (_, dispatch) => async (
  clubId,
  eventId,
  roundId,
  leaderboardId,
  enrollments
) => {
  const response: ILeaderboard = roundId
    ? await request.patch(api.admin.roundLeaderboard(leaderboardId), {
        enrollments
      })
    : await request.patch(api.admin.eventLeaderboards(clubId, eventId), { enrollments });

  if (isError(response)) {
    throw new Error(response.error);
  }

  dispatch({
    type: 'updateLeaderboard',
    value: response
  });
};
